module.exports = __webpack_public_path__ + "static/media/home_two_slide.95dc4d6e.jpg";